import { RepertoriazioneEnum } from "../enum/repertoriazione-enum";
import { ValoriDefaultFascicoloVO } from "./valori-default-fascicoloVO";

export class ValoriDefaultDocumentoVO extends ValoriDefaultFascicoloVO {
  riservato: boolean;

  daFirmare: boolean;

  condizioniConsultabilita: string;

  condizioniRiproduzione: string;

  protocollazione: boolean;

  repertoriazione: RepertoriazioneEnum;
}
